import type { MouseEventHandler, ReactNode, RefObject } from 'react';

import { Box, Drawer } from '@mui/material';

import Header from './header';

export interface SideDrawerProps {
  open: boolean;
  onClose: MouseEventHandler;
  onXButtonClose?: MouseEventHandler;
  title: string;
  subtitle?: ReactNode;
  icon: ReactNode;
  onHistoryClick?: () => void;
  isHistoryActive?: boolean;
  historyButtonRef?: RefObject<HTMLElement | null>;
  headerAction?: ReactNode;
  children?: ReactNode;
  width?: string | number;
}

const SideDrawer = ({
  open,
  onClose,
  onXButtonClose,
  title,
  subtitle,
  icon,
  onHistoryClick,
  isHistoryActive,
  historyButtonRef,
  headerAction,
  children,
  width = '846px'
}: SideDrawerProps) => {
  return (
    <Drawer
      anchor='right'
      ModalProps={{ keepMounted: true }}
      open={open}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(18, 22, 63, 0.80)',
            backdropFilter: 'blur(2px)'
          }
        },
        paper: {
          sx: {
            width: `min(${width}, 100vw)`,
            display: 'flex',
            flexDirection: 'column'
          }
        }
      }}
      sx={{
        left: 'auto'
      }}
      onClose={onClose}
    >
      <Header
        headerAction={headerAction}
        historyButtonRef={historyButtonRef}
        icon={icon}
        isHistoryActive={isHistoryActive}
        subtitle={subtitle}
        title={title}
        onClose={onXButtonClose ?? onClose}
        onHistoryClick={onHistoryClick}
      />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          background: 'var(--GX-Main-Background, #070818)'
        }}
      >
        {children}
      </Box>
    </Drawer>
  );
};

export default SideDrawer;
